"use strict";

exports["default"] = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
};

exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// /~/react-bootstrap/~/babel-runtime/helpers/interop-require-wildcard.js
// module id = 395
// module chunks = 0